// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/chart-track.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/chart-track/chart-track.js';

mount([g0]);
